const template = require('./vendor-name.html');

/**
 * selectedMasterVendor.masterVendorId = ''  <-- "Please select"
 * selectedMasterVendor.masterVendorId = -1  <-- "Add vendor not listed"
 */
const constants = {
  PLEASE_SELECT: '',
  ADD_NOT_LISTED: -1
};

export default function VendorNameDirective() {
  return {
    template,
    restrict: 'E',
    require: '^^form',
    scope: {
      newVendor: '=',
      masterVendors: '<'
    },
    link(scope, el, attrs, form) { // eslint-disable-line no-unused-vars
      scope.form = form;

      scope.changeSelection = (selectedMasterVendor) => {
        if (!selectedMasterVendor) {
          // The select is initializing, so don't change the viewmodel
          return;
        }
        if (selectedMasterVendor.masterVendorId === constants.PLEASE_SELECT) {
          // SWITCHING TO: "Please Select"
          selectedMasterVendor.masterVendorId = scope.prevMasterVendorId;
        } else if (selectedMasterVendor.masterVendorId === constants.ADD_NOT_LISTED) {
          // SWITCHING TO: "Add vendor not listed"
          // Store the last values
          scope.prevMasterVendorId = scope.newVendor.masterVendorId;
          // Set up the new state
          scope.newVendor.masterVendorId = constants.ADD_NOT_LISTED;
          scope.newVendor.name = scope.prevName;
          scope.showMasterList = false;
        } else if (
          scope.newVendor.vendorId < 1 || scope.newVendor.masterVendorId !== selectedMasterVendor.masterVendorId
        ) {
          // SWITCHING TO: a Master Vendor
          scope.newVendor.masterVendorId = selectedMasterVendor.masterVendorId;
          scope.prevName = scope.newVendor.name;
          scope.newVendor.name = selectedMasterVendor.name;
          /* This functionality is part of 1.6 */
          scope.newVendor.street = selectedMasterVendor.street;
          scope.newVendor.suite = selectedMasterVendor.suite;
          scope.newVendor.city = selectedMasterVendor.city;
          scope.newVendor.state = selectedMasterVendor.state;
          scope.newVendor.zip = selectedMasterVendor.zip;

          scope.$emit('refreshVendorAddress', scope.newVendor.name);
        }
      };

      scope.returnToMasterVendorList = () => {
        // Store the last values
        scope.prevName = scope.newVendor.name;
        // Set up the new state
        scope.selectedMasterVendor.masterVendorId = scope.prevMasterVendorId;
        scope.newVendor.masterVendorId = scope.prevMasterVendorId;
        scope.showMasterList = true;
      };
    },
    controller: [
      '$scope', ($scope) => {
        $scope.prevName = $scope.newVendor.masterVendorId > 0 ? '' : $scope.newVendor.name;
        $scope.prevMasterVendorId = $scope.newVendor.masterVendorId > 0
          ? $scope.newVendor.masterVendorId
          : constants.PLEASE_SELECT;

        if ($scope.newVendor.masterVendorId) {
          $scope.selectedMasterVendor = {
            masterVendorId: $scope.newVendor.masterVendorId
          };
        } else {
          $scope.selectedMasterVendor = {};
        }

        $scope.$watch('masterVendors', () => {
          const newVendor = $scope.newVendor.vendorId === -1;
          const hasSelectedMasterVendor = $scope.selectedMasterVendor.masterVendorId > constants.ADD_NOT_LISTED;
          const hasMasterVendors = !!$scope.masterVendors && $scope.masterVendors.length > 0;

          $scope.showMasterList = hasMasterVendors && (newVendor || hasSelectedMasterVendor);
        });
      }],
    replace: true,
  };
}
